var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.00002C12.035 0.631831 12.6319 0.631833 13.0001 1.00002C13.3683 1.36821 13.3683 1.96517 13.0001 2.33335L2.33343 13C1.96524 13.3682 1.36829 13.3682 1.0001 13C0.631911 12.6318 0.63191 12.0349 1.0001 11.6667L11.6668 1.00002Z",
    fill: "#9D9ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 11.6667C13.368 12.0349 13.368 12.6318 12.9998 13C12.6316 13.3682 12.0346 13.3682 11.6664 13L0.999776 2.33335C0.631585 1.96516 0.631585 1.36821 0.999775 1.00002C1.36797 0.631829 1.96492 0.631829 2.33311 1.00002L12.9998 11.6667Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d707048d.svg";
export { ForwardRef as ReactComponent };